/*
 * Author: Ben Zhao
 * File Created: Tuesday, 25-06-24 06:48 pm
 * Last Modified: Tuesday, 25-06-24 06:49 pm, by Ben Zhao
 */

const CheckedCircleFill = () => {
  return <svg width="13" height="12" viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" data-sentry-element="svg" data-sentry-component="CheckedCircleFill" data-sentry-source-file="index.tsx">
      <rect x="0.166016" width="12" height="12" rx="6" fill="#E84990" data-sentry-element="rect" data-sentry-source-file="index.tsx" />
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.56667 3.83172C9.73934 4.01047 9.7344 4.29536 9.55564 4.46802L5.76057 8.13371C5.47739 8.40724 5.02523 8.39647 4.75539 8.10977L2.76147 5.99123C2.59114 5.81025 2.59977 5.52546 2.78075 5.35512C2.96173 5.18479 3.24652 5.19342 3.41685 5.3744L5.27636 7.35013L8.93037 3.82068C9.10913 3.64802 9.39401 3.65296 9.56667 3.83172Z" fill="white" data-sentry-element="path" data-sentry-source-file="index.tsx" />
    </svg>;
};
export default CheckedCircleFill;